console.log("custom.js loaded — optimized strap count sync");

(function () {

  /* ======================= HANDLE CART CHANGE ======================= */
  const originalFetch = window.fetch;

  window.fetch = async function (resource, config = {}) {
    const url = typeof resource === "string" ? resource : "";
    const method = (config?.method || "").toUpperCase();
    const isSticky = url.includes("/cart/add") && method === "POST";
    const isChange = url.includes("/cart/change") && method === "POST";
    const response = await originalFetch(resource, config);

    if (isChange || isSticky) {
      console.log("CART CHANGE detected — syncing strapCount via _is_strap property");

      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          let newCount = 0;
          let walletCount = 0;
          cart.items.forEach(item => {
            console.log(item.properties,'proper')
            if (item.properties && item.properties._is_strap === "true") {
              newCount += item.quantity;
            }
            if(item.properties && item.properties._is_wallet === "true" ){
              walletCount += item.quantity;
            }
          });
          
          console.log("Updated strapCount:", newCount);
          console.log("updated walletCount", walletCount);
          localStorage.setItem("strapCount", newCount);
          localStorage.setItem("walletCount", walletCount);
          if(newCount>=3 && walletCount < 1 ){
            const popup = document.getElementById("strap-gift-popup");
            if (popup) popup.classList.add("active");
          }
        });
    }


    return response;
  };

  /* ======================= POPUP CLOSE EVENTS ======================= */
  document.addEventListener("DOMContentLoaded", () => {
    const popup = document.getElementById("strap-gift-popup");
    if (!popup) {
      console.log("Popup not found on DOM load");
      return;
    }

    const closeBtn = popup.querySelector(".strap-popup-close");
    const overlay = popup.querySelector(".strap-popup-overlay");

    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        console.log("Popup closed (close btn)");
        popup.classList.remove("active");
      });
    }

    if (overlay) {
      overlay.addEventListener("click", () => {
        console.log("Popup closed (overlay click)");
        popup.classList.remove("active");
      });
    }
  });

})();
